/* ==========================================================================
   KAION — Desconto automático por volume

   Assume o controle das alterações de quantidade no carrinho.
   Quando o tema tenta alterar uma linha de um produto com faixa, o pedido
   é cancelado e a família inteira é reconstruída na faixa de preço correta.

   Cada família calcula a própria faixa, sem misturar com as outras.

   ÓCULOS (RestVision) — agrupa por produto (lente)
     1 óculos  -> "1 Unidade"   R$ 275,90
     2 óculos  -> "2 Unidades"  R$ 209,95
     3 ou mais -> "3 Unidades"  R$ 189,97

   FITA (RestTape) — um produto só, agrupa pela propriedade "Cor"
     1 caixa   -> "1 Caixa"     R$ 147,90
     2 caixas  -> "2 Caixas"    R$ 90,95
     3 caixas  -> "3 Caixas"    R$ 74,97
     4 caixas  -> "4 Caixas"    R$ 71,22
     5 ou mais -> "5 Caixas"    R$ 67,98
     A fita é reconhecida sozinha pelo título da variante ("Caixa").
   ========================================================================== */
(function () {
  'use strict';

  /* A fita de nariz usa variantes "1 Unidade, 2 Unidades...", igual aos
     óculos. Então o título da variante não basta para separar as duas:
     a fita de nariz é reconhecida pelo endereço (handle) do produto.
     Se você renomear o produto, mantenha uma destas palavras no handle
     — ou deixe a tag "bundle-nasal" e troque a palavra aqui. */
  function ehNasal(handle) {
    return /airtape|air-tape|nariz|nasal/i.test(handle || '');
  }

  var FAMILIAS = {
    nasal: {
      handles: [],
      detectar: function (item) {
        return /unidade|caixa|embalagem|pacote/i.test(item.variant_title || '')
               && ehNasal(item.handle);
      },
      maxFaixa: 5,   /* quantas faixas de kit existem na fita de nariz */
      porCor: true
    },
    oculos: {
      /* sem endereço fixo: os óculos são reconhecidos pelo título
         da variante ("1 Unidade", "2 Unidades"...), do mesmo jeito
         que a fita. Assim, renomear produto não quebra nada. */
      handles: [],
      detectar: function (item) {
        return /unidade/i.test(item.variant_title || '') && !ehNasal(item.handle);
      },
      maxFaixa: 3,
      porCor: false
    },
    fita: {
      handles: [],                                  // descoberto pelo carrinho
      detectar: function (item) {
        return /caixa/i.test(item.variant_title || '') && !ehNasal(item.handle);
      },
      maxFaixa: 5,
      porCor: true
    }
  };

  var mapa = {};          // handle -> { faixa: variantId }
  var variantInfo = {};   // variantId -> { handle, familia }
  var carregados = {};    // handle -> true
  var ocupado = false;
  var nossoPedido = false; // true enquanto o próprio script mexe no carrinho

  /* ---------------- mapa de variantes ---------------- */

  function registrarProduto(p, familia) {
    if (!p) return;
    var faixas = {};
    p.variants.forEach(function (v) {
      var n = parseInt(String(v.title).trim().split(' ')[0], 10);
      if (!isNaN(n)) {
        faixas[n] = v.id;
        variantInfo[v.id] = { handle: p.handle, familia: familia, faixa: n };
      }
    });
    mapa[p.handle] = faixas;
    carregados[p.handle] = true;
  }

  function buscarProduto(handle) {
    return fetch('/products/' + handle + '.js', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function carregarFixos() {
    var pendentes = [];
    Object.keys(FAMILIAS).forEach(function (fam) {
      FAMILIAS[fam].handles.forEach(function (h) {
        if (!carregados[h]) pendentes.push({ h: h, fam: fam });
      });
    });
    if (!pendentes.length) return Promise.resolve();
    return Promise.all(pendentes.map(function (x) {
      return buscarProduto(x.h)
        .then(function (p) {
          if (p) registrarProduto(p, x.fam);
          else { carregados[x.h] = true; console.warn('KAION: produto não encontrado:', x.h); }
        })
        .catch(function () { carregados[x.h] = true; });
    }));
  }

  /* descobre produtos de família detectada (fita) que estão no carrinho */
  function garantirMapa(cart) {
    var pendentes = [];
    cart.items.forEach(function (item) {
      if (variantInfo[item.variant_id] || carregados[item.handle]) return;
      Object.keys(FAMILIAS).forEach(function (fam) {
        var F = FAMILIAS[fam];
        if (F.detectar && F.detectar(item) && pendentes.indexOf(item.handle + '|' + fam) === -1) {
          pendentes.push(item.handle + '|' + fam);
        }
      });
    });
    if (!pendentes.length) return Promise.resolve(cart);
    return Promise.all(pendentes.map(function (x) {
      var partes = x.split('|');
      return buscarProduto(partes[0]).then(function (p) {
        registrarProduto(p, partes[1]);
        if (p && FAMILIAS[partes[1]].handles.indexOf(p.handle) === -1) {
          FAMILIAS[partes[1]].handles.push(p.handle);
        }
      });
    })).then(function () { return cart; });
  }

  /* ---------------- regras ---------------- */

  function faixaPara(total, max) {
    if (total <= 1) return 1;
    return total >= max ? max : total;
  }

  /* Se a faixa calculada não existir no produto (kit removido do
     catálogo, por exemplo), cai para a maior faixa disponível
     abaixo dela. Sem isso o carrinho ficaria sem a linha. */
  function faixaDisponivel(handle, faixa) {
    var faixas = mapa[handle];
    if (!faixas) return null;
    if (faixas[faixa]) return faixa;
    var chaves = Object.keys(faixas).map(Number).sort(function (a, b) { return a - b; });
    var escolhida = null;
    chaves.forEach(function (n) { if (n <= faixa) escolhida = n; });
    return escolhida || chaves[0] || null;
  }

  function lerCarrinho() {
    return fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  function limparProps(props) {
    var out = {}, tem = false;
    if (!props) return null;
    Object.keys(props).forEach(function (k) {
      if (props[k] !== null && props[k] !== undefined && props[k] !== '') { out[k] = props[k]; tem = true; }
    });
    return tem ? out : null;
  }

  function chaveDe(item) {
    var info = variantInfo[item.variant_id];
    if (!info) return null;
    if (FAMILIAS[info.familia].porCor) {
      var cor = (item.properties && item.properties['Cor']) || '';
      return info.handle + '||' + cor;
    }
    return info.handle;
  }

  /* estado = { chave: { handle, familia, qtd, props } } na ordem do carrinho */
  function estadoAtual(cart) {
    var out = {}, ordem = [];
    cart.items.forEach(function (item) {
      var info = variantInfo[item.variant_id];
      if (!info) return;
      var k = chaveDe(item);
      if (!out[k]) {
        out[k] = {
          handle: info.handle,
          familia: info.familia,
          qtd: 0,
          props: FAMILIAS[info.familia].porCor ? limparProps(item.properties) : null
        };
        ordem.push(k);
      }
      out[k].qtd += item.quantity;
    });
    out.__ordem = ordem;
    return out;
  }

  function totalDaFamilia(estado, fam) {
    var t = 0;
    estado.__ordem.forEach(function (k) {
      if (estado[k] && estado[k].familia === fam) t += estado[k].qtd;
    });
    return t;
  }

  function reconstruir(desejado, familias) {
    nossoPedido = true;
    var faixa = {};
    familias.forEach(function (fam) {
      faixa[fam] = faixaPara(totalDaFamilia(desejado, fam), FAMILIAS[fam].maxFaixa);
    });

    return lerCarrinho().then(function (cart) {
      var updates = {};
      cart.items.forEach(function (item) {
        var info = variantInfo[item.variant_id];
        if (info && familias.indexOf(info.familia) !== -1) updates[item.key] = 0;
      });

      var novos = [];
      desejado.__ordem.forEach(function (k) {
        var d = desejado[k];
        if (!d || d.qtd <= 0 || familias.indexOf(d.familia) === -1) return;
        var fx = faixaDisponivel(d.handle, faixa[d.familia]);
        var id = fx && mapa[d.handle] ? mapa[d.handle][fx] : null;
        if (!id) { console.warn('KAION: sem variante para', d.handle, 'faixa', faixa[d.familia]); return; }
        var linha = { id: id, quantity: d.qtd };
        if (d.props) linha.properties = d.props;
        novos.push(linha);
      });

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates })
      }).then(function () {
        if (!novos.length) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: novos })
        });
      }).then(function (r) {
        setTimeout(function () { nossoPedido = false; }, 900);
        return r;
      }).catch(function (e) {
        nossoPedido = false;
        throw e;
      });
    });
  }

  function familiasErradas(cart, estado) {
    var erradas = [];
    Object.keys(FAMILIAS).forEach(function (fam) {
      var total = totalDaFamilia(estado, fam);
      if (!total) return;
      var faixa = faixaPara(total, FAMILIAS[fam].maxFaixa);
      var errada = cart.items.some(function (item) {
        var info = variantInfo[item.variant_id];
        if (!info || info.familia !== fam) return false;
        var fx = faixaDisponivel(info.handle, faixa);
        var certo = fx && mapa[info.handle] ? mapa[info.handle][fx] : null;
        return certo && item.variant_id !== certo;
      });
      if (errada) erradas.push(fam);
    });
    return erradas;
  }

  function corrigirFaixa() {
    if (ocupado) return Promise.resolve();
    ocupado = true;

    return carregarFixos()
      .then(lerCarrinho)
      .then(garantirMapa)
      .then(function (cart) {
        var estado = estadoAtual(cart);
        var erradas = familiasErradas(cart, estado);
        if (!erradas.length) { ocupado = false; return; }

        return reconstruir(estado, erradas).then(function () {
          atualizarDrawer();
          setTimeout(function () { ocupado = false; }, 800);
        });
      })
      .catch(function (e) {
        console.warn('KAION:', e);
        ocupado = false;
      });
  }

  function atualizarDrawer() {
    ['cart:refresh', 'cart:build', 'cart:updated', 'cart:change'].forEach(function (n) {
      document.dispatchEvent(new CustomEvent(n, { bubbles: true }));
      document.body.dispatchEvent(new CustomEvent(n, { bubbles: true }));
    });
    if (window.theme && typeof window.theme.cartRefresh === 'function') {
      try { window.theme.cartRefresh(); } catch (e) {}
    }
  }

  /* ---------------- interceptador ---------------- */

  function instalarInterceptador() {
    if (window.fetch.__kaionVol) return;
    var anterior = window.fetch;

    var novo = function (url, opts) {
      var self = this;
      var ehChange = typeof url === 'string' && url.indexOf('/cart/change') !== -1;

      if (ehChange && opts && opts.body) {
        var dados = null;
        try {
          dados = (typeof opts.body === 'string') ? JSON.parse(opts.body) : null;
        } catch (e) { dados = null; }

        if (dados && (dados.id || dados.line)) {
          return lerCarrinho().then(garantirMapa).then(function (cart) {
            var alvo = null;
            if (dados.id) {
              alvo = cart.items.filter(function (i) { return i.key === dados.id; })[0] ||
                     cart.items.filter(function (i) { return String(i.variant_id) === String(dados.id); })[0];
            } else if (dados.line) {
              alvo = cart.items[parseInt(dados.line, 10) - 1];
            }

            var info = alvo ? variantInfo[alvo.variant_id] : null;
            if (!info) return anterior.call(self, url, opts);

            var desejado = estadoAtual(cart);
            var k = chaveDe(alvo);
            var novaQtd = parseInt(dados.quantity, 10);
            if (isNaN(novaQtd)) novaQtd = 0;

            if (novaQtd <= 0) { delete desejado[k]; }
            else { desejado[k].qtd = novaQtd; }

            ocupado = true;
            return reconstruir(desejado, [info.familia])
              .then(lerCarrinho)
              .then(function (novoCart) {
                atualizarDrawer();
                setTimeout(function () { ocupado = false; }, 800);
                return new Response(JSON.stringify(novoCart), {
                  status: 200,
                  headers: { 'Content-Type': 'application/json' }
                });
              });
          });
        }
      }

      var ehAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;

      /* Nada de mexer na quantidade pedida.
         Havia aqui um bloco que multiplicava a quantidade pela faixa
         da variante, e ele quebrava os bundles: pedir 2 do kit de 2
         virava 4 no carrinho. A correção de faixa abaixo já resolve
         o preço sem tocar na quantidade que a pessoa escolheu. */

      return anterior.call(self, url, opts).then(function (resp) {
        /* pedidos feitos pelo próprio script não disparam nova conferência:
           era isso que duplicava as linhas do carrinho */
        if (ehAdd && !ocupado && !nossoPedido) setTimeout(corrigirFaixa, 350);
        return resp;
      });
    };

    novo.__kaionVol = true;
    window.fetch = novo;
  }

  /* garante que os produtos com faixa do carrinho e da página atual
     já estejam mapeados antes do primeiro clique */
  function mapearPagina() {
    var handles = [];
    document.querySelectorAll('[data-product-handle]').forEach(function (el) {
      var h = el.getAttribute('data-product-handle');
      if (h && handles.indexOf(h) === -1) handles.push(h);
    });
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (m && handles.indexOf(m[1]) === -1) handles.push(m[1]);
    if (!handles.length) return Promise.resolve();

    return Promise.all(handles.map(function (h) {
      if (carregados[h]) return null;
      return buscarProduto(h).then(function (p) {
        if (!p || !p.variants) { carregados[h] = true; return; }
        var ehFaixa = p.variants.some(function (v) {
          return /unidade|caixa|embalagem|pacote/i.test(v.title || '');
        });
        if (!ehFaixa) { carregados[h] = true; return; }
        var fam = ehNasal(p.handle)
          ? 'nasal'
          : (/caixa/i.test(p.variants[0].title || '') ? 'fita' : 'oculos');
        registrarProduto(p, fam);
      }).catch(function () { carregados[h] = true; });
    }));
  }

  /* ---------------- rede de segurança ----------------
     A compra rápida da coleção adiciona por XMLHttpRequest,
     que o interceptador de fetch não enxerga. Aqui cobrimos
     esse caminho e qualquer outro: depois de qualquer
     alteração no carrinho, conferimos a faixa. */

  function instalarXHR() {
    if (XMLHttpRequest.prototype.__kaionVol) return;
    var abrirOriginal = XMLHttpRequest.prototype.open;
    var enviarOriginal = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (metodo, url) {
      this.__kaionUrl = url;
      return abrirOriginal.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var self = this;
      var url = String(self.__kaionUrl || '');
      var mexeNoCarrinho = url.indexOf('/cart/add') !== -1 ||
                           url.indexOf('/cart/change') !== -1 ||
                           url.indexOf('/cart/update') !== -1;

      /* só pedidos de fora: os nossos já são corrigidos na origem */
      if (mexeNoCarrinho && !nossoPedido && !ocupado) {
        self.addEventListener('load', function () {
          if (nossoPedido || ocupado) return;
          setTimeout(function () {
            if (!ocupado) corrigirFaixa();
          }, 400);
        });
      }
      return enviarOriginal.apply(this, arguments);
    };

    XMLHttpRequest.prototype.__kaionVol = true;
  }

  function iniciar() {
    instalarXHR();
    carregarFixos().then(mapearPagina).then(function () {
      instalarInterceptador();
      corrigirFaixa();
      [800, 2000, 4000].forEach(function (ms) {
        setTimeout(function () { instalarInterceptador(); instalarXHR(); }, ms);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();